import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany } from '@apexdesigner/schema-tools';

export const user = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    email: z.string().describe('Email - User email address'),

    lastSeen: z.coerce
      .date()
      .nullable()
      .optional()
      .disabled()
      .describe(
        'Last Seen - When the user last made an authenticated request\n\nSet on first login and refreshed at most every few minutes by\n`touchLastSeen`. Empty for a user added by email who has never signed in.',
      ),

    roleAssignments: hasMany('RoleAssignment'),

    matchesRun: hasMany('Match', 'runById'),

    groupMatchesRun: hasMany('GroupMatch', 'runById'),
  })
  .describe('Authenticated user identified by email address.')
  .as('User');

export { user as userSchema };
